export default __webpack_public_path__ + "static/media/carousel2.278fcea1.jpg";